import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ROLES, URLS, USER_TYPES } from 'src/app/constant/constant';
import { TokenService } from '../../../utilities/token.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { GraphqlService } from 'src/app/services/graphql.service';
import { DoctorMenuService } from './app.menu.service';

@TraceClassDecorator()
@Component({
    selector: 'doctor-app-menu',
    templateUrl: './app.menu.component.html'
})
export class DoctorAppMenuComponent implements OnInit {
    model: any[];

    login_role: any;
    subscription_status: boolean = false;
    medical_professionals = USER_TYPES;
    isPrimaryProvider: Boolean = false;
    slug: string = "";
    provider_id: string = "";
    is_uk_country: boolean = false;
    constructor(private readonly tokenUtil: TokenService,
        private providerstateService: ProviderStateService,
        private readonly graphqlService: GraphqlService,
        private readonly doctorMenuService: DoctorMenuService
    ) { }

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.provider_id = this.providerstateService.getProviderId();
        this.login_role = this.tokenUtil.findRoleId();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        console.log(this.subscription_status, "testing54");
        this.isPrimaryProvider = this.providerstateService.getIsPrimaryProvider();
        await this.getSubscriptionStatus(true);
        this.addMenuItems()
    }

    addMenuItems() {
        console.log({ "RS": this.subscription_status })
        if (this.login_role == ROLES.Doctor) {
            this.model = [
                {
                    label: 'Doctor Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dashboard`]
                },
                {
                    label: 'Profiles',
                    icon: 'fa fa-fw fa-user-md',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/doctordata`]
                },
                {
                    label: 'Appointments',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/appointments`]
                },
                {
                    label: 'Message Center',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/message-center`]
                },
                {
                    label: 'Past Consultations',
                    icon: 'fa fa-fw fa-envelope-open-o',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/patients`]
                },
                {
                    label: 'Add/Edit Schedule',
                    icon: 'fa fa-fw fa-credit-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/schedule`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];

            if (this.is_uk_country) {
                this.model.splice(2, 0, {
                    label: 'Certificates',
                    icon: 'pi pi-briefcase',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/doctor-certificates`]
                });
            }
        } else if (this.login_role == ROLES.Admin) {
            this.model = [
                {
                    label: 'Doctor Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dashboard`]
                },
                {
                    label: 'Appointments',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/appointments`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];
        } else if (
            this.login_role == ROLES.SuperAdmin ||
            this.login_role == ROLES.SuperAdmin_Doctor ||
            this.login_role == ROLES.Admin_Doctor
        ) {
            if (this.isPrimaryProvider) {
                this.model = [
                    {
                        label: 'Doctor Dashboard',
                        icon: 'fa fa-fw fa-bar-chart',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dashboard`]
                    },
                    {
                        label: 'Doctor Registration',
                        icon: 'fa fa-fw fa-user-plus',
                        items: [
                            {
                                label: 'Registration',
                                icon: 'pi pi-user-plus',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dregistration`]
                            },
                            {
                                label: 'Pending/Approvals',
                                icon: 'fa fa-fw fa-upload',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/pendingApprovals`]
                            },
                            {
                                label: 'Registered',
                                icon: 'fa fa-fw fa-upload',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/registered`]
                            },
                            {
                                label: 'Termination',
                                icon: 'fa fa-fw fa-upload',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/termination`]
                            }
                        ]
                    },
                    {
                        label: 'Profiles',
                        icon: 'fa fa-fw fa-user-md',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/doctordata`],

                    },
                    {
                        label: 'Approve Provider',
                        icon: 'pi pi-envelope',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/approve-provider`]
                    },
                    {
                        label: 'Appointments',
                        icon: 'fa fa-fw fa-address-card',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/appointments`],

                    },
                    {
                        label: 'Message Center',
                        icon: 'pi pi-envelope',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/message-center`],

                    },
                    {
                        label: 'Past Consultations',
                        icon: 'pi pi-book',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/patients-sadmin`],

                    },
                    {
                        label: 'Departments',
                        icon: 'fa fa-fw fa-list-alt',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/departments`],

                    },
                    {
                        label: 'Analytics',
                        icon: 'fa fa-fw fa-list-alt',

                        items: [
                            {
                                label: 'Metrics Dashboard',
                                icon: 'fa fa-fw fa-list-alt',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/analytics`]
                            },
                            {
                                label: 'Marketing Dashboard',
                                icon: 'fa fa-fw fa-list-alt',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/marketing-analytics`]
                            },
                        ]
                    },
                    {
                        label: 'Accounts',
                        icon: 'pi pi-dollar',

                        items: [
                            {
                                label: 'Patients',
                                icon: 'pi pi-money-bill',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/patients`]
                            },
                            {
                                label: 'Doctors',
                                icon: 'pi pi-money-bill',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/doctors`]
                            },
                            {
                                label: 'Patient Refunds',
                                icon: 'pi pi-wallet',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/patients/refund`]
                            }
                        ]
                    },
                    {
                        label: 'Add/Edit Schedule',
                        icon: 'pi pi-calendar-plus',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/schedule`]
                    },
                    {
                        label: 'Transactions',
                        icon: 'fa fa-fw fa-credit-card',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/provider-transactions`]
                    },
                    {
                        label: 'Feedback',
                        icon: 'pi pi-comment',
                        items: [
                            {
                                label: 'Feedback',
                                icon: 'fas fa-comment-alt',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/feedback`]
                            }
                            // {
                            //     label: 'Patients', icon: 'fa fa-fw fa-upload',
                            //     routerLink:['/doctor/patientaccounts']
                            // }
                        ]
                    },
                    {
                        label: 'Lookup',
                        icon: 'pi pi-user',
                        items: [
                            {
                                label: 'Lookup Patients',
                                icon: 'pi pi-user-edit',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/lookup-search-p`]
                            },
                            {
                                label: 'Lookup Doctors',
                                icon: 'pi pi-user-plus',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/lookup-search-d`]
                            }
                        ]
                    },
                    {
                        label: 'Administration',
                        icon: 'pi pi-shield',
                        items: [
                            {
                                label: 'Discount Coupons',
                                icon: 'pi pi-ticket',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/admin/coupons`]
                                
                            },
                            {
                                label: 'App Versions',
                                icon: 'pi pi-sliders-v',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/admin/app/versions`]
                            }
                        ]
                    },
                    {
                        label: 'Sign Out',
                        icon: 'fa fa-fw fa-power-off',
                        routerLink: [`/${this.slug}/logout`]
                    }
                ];
            } else {

                this.model = [
                    {
                        label: 'Doctor Dashboard',
                        icon: 'fa fa-fw fa-bar-chart',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dashboard`]
                    },
                    {
                        label: 'Manage Clinic',
                        icon: 'pi pi-user',
                        disabled: !this.subscription_status,
                        items: [{
                            label: 'License Plans',
                            icon: 'fa fa-fw fa-list-alt',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/license_plans`],
                            disabled: !this.subscription_status
                        }, {
                            label: 'Pricing',
                            icon: 'fa fa-fw fa-list-alt',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/priority-list`],
                            disabled: !this.subscription_status
                        },
                        {
                            label: 'Api Keys',
                            icon: 'fa fa-fw fa-list-alt',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/api_keys`
                            ],
                            disabled: !this.subscription_status
                        },
                        {
                            label: 'Add Countries',
                            icon: 'fa fa-fw fa-list-alt',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/provider-countries`
                            ],
                            disabled: !this.subscription_status
                        },
                        {
                            label: 'Update Logo',
                            icon: 'fa fa-fw fa-list-alt',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/update-logo`],
                            disabled: !this.subscription_status
                        },
                        {
                            label: 'Transactions',
                            icon: 'fa fa-fw fa-credit-card',
                            routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/provider-transactions`],
                            disabled: !this.subscription_status
                        }],

                    },
                    {
                        label: 'Doctor Registration',
                        icon: 'fa fa-fw fa-user-plus',

                        items: [
                            {
                                label: 'Registration',
                                icon: 'pi pi-user-plus',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/dregistration`],

                            },
                            // {
                            //     label: 'Pending/Approvals',
                            //     icon: 'fa fa-fw fa-upload',
                            //     routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/pendingApprovals`]
                            // },
                            {
                                label: 'Registered',
                                icon: 'fa fa-fw fa-upload',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/registered`],

                            },
                            {
                                label: 'Termination',
                                icon: 'fa fa-fw fa-upload',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/termination`],

                            }
                        ], disabled: !this.subscription_status
                    },
                    {
                        label: 'Profiles',
                        icon: 'fa fa-fw fa-user-md',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/doctordata`],
                        disabled: !this.subscription_status
                    },
                    // {
                    //     label: 'Approve Provider',
                    //     icon: 'pi pi-envelope',
                    //     routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/approve-provider`]
                    // },
                    {
                        label: 'Appointments',
                        icon: 'fa fa-fw fa-address-card',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/appointments`],
                        disabled: !this.subscription_status
                    },
                    {
                        label: 'Message Center',
                        icon: 'pi pi-envelope',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/message-center`],
                        disabled: !this.subscription_status
                    },
                    {
                        label: 'Past Consultations',
                        icon: 'pi pi-book',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/patients-sadmin`],
                        disabled: !this.subscription_status
                    },
                    {
                        label: 'Departments',
                        icon: 'fa fa-fw fa-list-alt',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/departments`],
                        disabled: !this.subscription_status
                    },
                    {
                        label: 'Analytics',
                        icon: 'fa fa-fw fa-list-alt',

                        items: [
                            {
                                label: 'Metrics Dashboard',
                                icon: 'fa fa-fw fa-list-alt',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/analytics`]
                            },
                            {
                                label: 'Marketing Dashboard',
                                icon: 'fa fa-fw fa-list-alt',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/marketing-analytics`]
                            },
                        ], disabled: !this.subscription_status
                    },
                    {
                        label: 'Accounts',
                        icon: 'pi pi-dollar',

                        items: [
                            {
                                label: 'Patients',
                                icon: 'pi pi-money-bill',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/patients`]
                            },
                            {
                                label: 'Doctors',
                                icon: 'pi pi-money-bill',
                                routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/doctors`],
                            },
                            // {
                            //     label: 'Patient Refunds',
                            //     icon: 'pi pi-wallet',
                            //     routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/accounts/patients/refund`]
                            // }
                        ], disabled: !this.subscription_status
                    },

                    {
                        label: 'Add/Edit Schedule',
                        icon: 'pi pi-calendar-plus',
                        routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/schedule`], disabled: !this.subscription_status
                    },

                    // {
                    //     label: 'Feedback',
                    //     icon: 'pi pi-comment',
                    //     items: [
                    //         {
                    //             label: 'Feedback',
                    //             icon: 'fas fa-comment-alt',
                    //             routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/feedback`]
                    //         }
                    //         // {
                    //         //     label: 'Patients', icon: 'fa fa-fw fa-upload',
                    //         //     routerLink:['/doctor/patientaccounts']
                    //         // }
                    //     ]
                    // },
                    // {
                    //     label: 'Lookup',
                    //     icon: 'pi pi-user',
                    //     disabled: !this.subscription_status,
                    //     items: [
                    //         {
                    //             label: 'Lookup Patients',
                    //             icon: 'pi pi-user-edit',
                    //             routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/lookup-search-p`]
                    //         },
                    //         {
                    //             label: 'Lookup Doctors',
                    //             icon: 'pi pi-user-plus',
                    //             routerLink: [`/${this.slug}/${this.medical_professionals['DOCTOR']}/lookup-search-d`]
                    //         }
                    //     ]
                    // },
                    // {
                    //     label: 'Administration',
                    //     icon: 'pi pi-shield',
                    //     items: [
                    //         {
                    //             label: 'Discount Coupons',
                    //             icon: 'pi pi-ticket',
                    //             routerLink: [
                    //                 '/' +
                    //                 this.medical_professionals['DOCTOR'] +
                    //                 '/admin/coupons'
                    //             ]
                    //         },
                    //         {
                    //             label: 'App Versions',
                    //             icon: 'pi pi-sliders-v',
                    //             routerLink: [
                    //                 '/' +
                    //                 this.medical_professionals['DOCTOR'] +
                    //                 '/admin/app/versions'
                    //             ]
                    //         }
                    //     ]
                    // },
                    {
                        label: 'Sign Out',
                        icon: 'fa fa-fw fa-power-off',
                        routerLink: [`/${this.slug}/logout`]
                    }
                ];
            }
        } else if (this.login_role == ROLES.Other_Medical_Professional) {
            this.model = [
                {
                    label: 'Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS']}/dashboard`]
                },
                {
                    label: 'Profiles',
                    icon: 'fa fa-fw fa-user-md',
                    routerLink: [`/${this.slug}/${this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS']}/profiles`]
                },
                {
                    label: 'Appointments',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS']}/appointments`]
                },
                {
                    label: 'Message Center',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS']}/message-center`]
                },
                {
                    label: 'Past Consultations',
                    icon: 'fa fa-fw fa-envelope-open-o',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'OTHER-MEDICAL-PROFESSIONALS'
                    ]}/patients`]
                },
                {
                    label: 'Add/Edit Schedule',
                    icon: 'fa fa-fw fa-credit-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'OTHER-MEDICAL-PROFESSIONALS'
                    ]}/schedules`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];
        } else if (this.login_role == ROLES.Other_Medical_Professional_Admin) {
            this.model = [
                {
                    label: 'Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'OTHER-MEDICAL-PROFESSIONALS'
                    ]}/dashboard`]
                },
                {
                    label: 'Appointments',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'OTHER-MEDICAL-PROFESSIONALS'
                    ]}/appointments`]
                },
                {
                    label: 'Past Consultations',
                    icon: 'fa fa-fw fa-envelope-open-o',
                    routerLink: [`/${this.slug}/${this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS']}/patients`]
                },
                {
                    label: 'Add/Edit Schedule',
                    icon: 'fa fa-fw fa-credit-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'OTHER-MEDICAL-PROFESSIONALS'
                    ]}/schedules`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];
        }
        else if (this.login_role == ROLES.Support) {
            this.model = [
                {
                    label: 'Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'SUPPORT'
                    ]}/fetch-list`]
                },
                {
                    label: 'Create Request',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'SUPPORT'
                    ]}/create-user`]
                },
                {
                    label: 'Appointments',
                    icon: 'fa fa-fw fa-address-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'SUPPORT'
                    ]}/appointments`]
                },
                {
                    label: 'Add/Edit Schedule',
                    icon: 'fa fa-fw fa-credit-card',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'SUPPORT'
                    ]}/schedules`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];
        }
        else if (this.login_role == ROLES.Vendor) {
            this.model = [
                {
                    label: 'Dashboard',
                    icon: 'fa fa-fw fa-bar-chart',
                    routerLink: [`/${this.slug}/${this.medical_professionals[
                        'VENDOR'
                    ]}/fetch-users`]
                },
                {
                    label: 'Sign Out',
                    icon: 'fa fa-fw fa-power-off',
                    routerLink: [`/${this.slug}/logout`]
                }
            ];
        }

        this.doctorMenuService.setItems(this.model)

    }

    async getSubscriptionStatus(isActive: Boolean) {
        await this.graphqlService.getSubscriptionStatus(isActive).toPromise().then(
            (result) => {
                console.log("function called")
                console.log(result.data, "testing445")
                if (result.data['fetchProviderLicenses']['providerLicense'][0]['is_active']) {
                    this.subscription_status = true;
                }
                console.log(this.subscription_status, "test321")
            }

        ).catch((error) => {
            console.error('There was an error fetching the provider licenses from the API', error);
        });
    }


    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }
}
